/**
 * Shared Station — Frontend Interceptor
 * =======================================
 * Add to your Shopify theme:
 *   Online Store → Themes → Edit Code → Assets → Add new asset
 *   Name it: shared-station.js
 *
 * Then in your product template (product.liquid or product-form.liquid) add:
 *   <script src="{{ 'shared-station.js' | asset_url }}" defer></script>
 *
 * ASSUMES your checkbox has:
 *   <input type="checkbox" id="shared-station-checkbox">
 * And your Add to Cart button is a standard Shopify submit button.
 */

(function() {
	// ─── CONFIG ────────────────────────────────────────────────────────────────
	const CHECKOUT_ENDPOINT = 'https://is.deflux.co.nz/checkout.php'; // Your PHP file URL
	const CHECKBOX_SELECTOR = 'input.checkbox[type="checkbox"][value="Yes"][form^="product-form-template"]';
	const FORM_SELECTOR = 'form[action="/cart/add"]';
	const PRICE_SELECTOR = '.price__regular .price-item--regular, .price .price-item, [class*="price"] .money';
	const DISCOUNT_PERCENT = 25;
	// ────────────────────────────────────────────────────────────────────────────

	let originalPriceCents = null;

	// ─── HELPERS ─────────────────────────────────────────────────────────────────
	function getCheckbox() {
		return document.querySelector(CHECKBOX_SELECTOR);
	}
	function getForm() {
		return document.querySelector(FORM_SELECTOR);
	}
	function getPriceEl() {
		return document.querySelector(PRICE_SELECTOR);
	}

	function parsePrice(str) {
		return Math.round(parseFloat(str.replace(/[^0-9.]/g, '')) * 100);
	}

	function formatPrice(cents) {
		return '$' + (cents / 100).toFixed(2);
	}

	function getVariantId() {
		// Try hidden variant input first
		const variantInput = document.querySelector('input[name="id"], select[name="id"]');
		return variantInput ? variantInput.value : null;
	}

	function getQuantity() {
		const qtyInput = document.querySelector('input[name="quantity"]');
		return qtyInput ? parseInt(qtyInput.value) || 1 : 1;
	}

	function getLineItemProperties() {
		const props = {};
		const inputs = document.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');
		inputs.forEach(input => {
			const match = input.name.match(/properties\[(.+)\]/);
			if (match) {
				props[match[1]] = input.value;
			}
		});
		return props;
	}

	// ─── PRICE DISPLAY ───────────────────────────────────────────────────────────
	function updateDisplayPrice(isShared) {
		const priceEl = getPriceEl();
		if (!priceEl) return;

		if (originalPriceCents === null) {
			originalPriceCents = parsePrice(priceEl.textContent);
		}

		removeSavingsBadge();

		if (isShared) {
			const discounted = Math.round(originalPriceCents * (1 - DISCOUNT_PERCENT / 100));
			priceEl.textContent = formatPrice(discounted);
			priceEl.style.color = '#2a7a2a';
			showSavingsBadge(originalPriceCents, discounted);
		} else {
			priceEl.textContent = formatPrice(originalPriceCents);
			priceEl.style.color = '';
		}
	}

	function showSavingsBadge(original, discounted) {
		const savings = original - discounted;
		const badge = document.createElement('div');
		badge.id = 'shared-station-savings';
		badge.style.cssText = `
      margin-top: 6px;
      background: #e8f5e9;
      color: #2a7a2a;
      font-size: 0.85em;
      padding: 4px 10px;
      border-radius: 4px;
      font-weight: 600;
      display: inline-block;
    `;
		badge.textContent = `You save ${formatPrice(savings)} — Shared Station discount applied`;
		const priceEl = getPriceEl();
		if (priceEl && priceEl.parentNode) {
			priceEl.parentNode.insertBefore(badge, priceEl.nextSibling);
		}
	}

	function removeSavingsBadge() {
		const el = document.getElementById('shared-station-savings');
		if (el) el.remove();
	}

	// ─── CHECKOUT INTERCEPT ───────────────────────────────────────────────────────
	function interceptForm(form) {
		form.addEventListener('submit', async function(e) {
			const checkbox = getCheckbox();

			// If checkbox not ticked — let Shopify handle it normally
			if (!checkbox || !checkbox.checked) return;

			// Shared station — intercept and use Draft Order instead
			e.preventDefault();

			const variantId = getVariantId();
			const quantity = getQuantity();
			const properties = getLineItemProperties();

			if (!variantId) {
				console.error('[Shared Station] Could not find variant ID');
				alert('Something went wrong. Please try again.');
				return;
			}

			// Show loading state on button
			const submitBtn = form.querySelector('[type="submit"]');
			const originalBtnText = submitBtn ? submitBtn.textContent : '';
			if (submitBtn) {
				submitBtn.textContent = 'Processing...';
				submitBtn.disabled = true;
			}

			try {
				const response = await fetch(CHECKOUT_ENDPOINT, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						variant_id: parseInt(variantId),
						quantity: quantity,
						is_shared: true,
						properties: properties,
					}),
				});

				const data = await response.json();

				if (data.success && data.checkout_url) {
					// Redirect to the Draft Order checkout
					window.location.href = data.checkout_url;
				} else {
					console.error('[Shared Station] Draft order error:', data);
					alert('Could not create your booking. Please try again or contact us.');
					if (submitBtn) {
						submitBtn.textContent = originalBtnText;
						submitBtn.disabled = false;
					}
				}
			} catch (err) {
				console.error('[Shared Station] Network error:', err);
				alert('A network error occurred. Please try again.');
				if (submitBtn) {
					submitBtn.textContent = originalBtnText;
					submitBtn.disabled = false;
				}
			}
		});
	}

	// ─── INIT ─────────────────────────────────────────────────────────────────────
	function init() {
		const checkbox = getCheckbox();
		const form = getForm();

		if (!checkbox || !form) return; // Not a shared station product page

		// Update price display on checkbox change
		checkbox.addEventListener('change', function() {
			updateDisplayPrice(this.checked);
		});

		// If already ticked on load
		if (checkbox.checked) {
			updateDisplayPrice(true);
		}

		// Intercept form submit
		interceptForm(form);

		console.log('[Shared Station] Initialised.');
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
